import React from 'react';
import PropTypes from 'prop-types';
import ResultsWrapper from './ResultsWrapper';
import { getStoreDealsTable } from './config';
import ResultsDeals from './ResultsDeals';
import LoadingOverlay from '../LoadingOverlay';

function ResultsUser({ query, dealer, deals, ...rest }) {
  return (
    <LoadingOverlay active={deals.fetching}>
      <ResultsDeals
        {...rest}
        tableDefinition={getStoreDealsTable(dealer)}
        page={query.page}
        dealTotal={(deals.data || {}).total || 0}
        dealList={(deals.data || {}).data || []}
        disabled={deals.fetching}
        dealer={dealer}
      />
    </LoadingOverlay>
  );
}

ResultsUser.propTypes = {
  query: PropTypes.object.isRequired,
  deals: PropTypes.object.isRequired,
  dealer: PropTypes.object.isRequired,
};

export default ResultsWrapper(ResultsUser);
